<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
          >
            <i class="fa fa-plus"></i>
            New Product Tag
          </b-button>
        </div>
        <div>
          <ProductTagDialog
            :myIteration="componentKey"
            @filterList="myLoadComponent"
          >
            <div slot="header">
              <!-- <h2>{{ mySelected.Quantity }}</h2> -->
            </div>
            <div slot="details">
              <!-- <div>{{ mySelected.Description }}</div> -->
            </div>
          </ProductTagDialog>
        </div>
        <div>
          <StyledDialog
            @filterList="myLoadComponent"
            :CurrentObject="mySelected"
            EntityType="ProductTag"
          >
            <div slot="header"></div>
            <div slot="details">
              <h2>Tag: {{ mySelected.ProductTagName }}</h2>
              <div>Keywords: {{ mySelected.ProductTagDesc }}</div>
            </div>
            <span slot="entityType">ProductTag</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import ProductTagDialog from "@/components/dialogs/ProductTagModal.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "ProductTagList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "ProductTagName",
          label: "Tag Name",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "ProductTagDesc",
          label: "Keywords",
          sortable: true,
          thStyle: "width: 50%;"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      componentKey: 0
    };
  },
  props: {},
  components: {
    cTable,
    ProductTagDialog,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.product.product_tags.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["product", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    async myLoadComponent() {
      await this.$store.dispatch("product/fetchProductTags");
      this.filterList();
    },
    async myRowClickHandler(record, index) {
      await this.$store
        .dispatch("product/loadProductTagEdit", record.ProductTagID)
        .then(() => {
          //alert(this.$store.state.product.transaction_edit.Quantity);
          //this.$router.push({ name: "Product" });
          this.$bvModal.show("modal-4");
        });
    },
    async newEntity() {
      await this.$store
        .dispatch("product/newProductTag", this.createFreshObject())
        .then(() => {
          //alert(this.$store.state.product.transaction_edit.Quantity);
          //this.$router.push({ name: "Product" });
          this.$bvModal.show("modal-4");
        });
    },
    async SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        ProductTagID: -1,
        ProductTagName: "",
        ProductTagDesc: ""
      };
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.product.product_tags.filter(
        tag =>
          tag.ProductTagName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          tag.ProductTagDesc.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
